// extracted by mini-css-extract-plugin
export default {"Mask":"SliderNumber_Mask__YhqzV","SliderContainer":"SliderNumber_SliderContainer__Ty-Aw"};